import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu--company-show--city-company-card--component', class extends Controller {
  static targets = ['tags', 'toggle', 'toggleText', 'tagsPc', 'togglePc', 'toggleTextPc']

  connect() {
    // CSSが適用されてから高さを計算するため少し遅延
    requestAnimationFrame(() => {
      this.checkOverflow()
      this.checkOverflowPc()
    })
    this.boundHandleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.boundHandleResize)
  }

  disconnect() {
    window.removeEventListener('resize', this.boundHandleResize)
  }

  handleResize() {
    this.checkOverflow()
    this.checkOverflowPc()
  }

  // SP用タグのオーバーフローチェック
  checkOverflow() {
    if (!this.hasTagsTarget || !this.hasToggleTarget) return

    const tags = this.tagsTarget
    const toggle = this.toggleTarget

    // 展開中は非表示にしない
    if (tags.classList.contains('is-expanded')) {
      toggle.style.display = 'flex'
      return
    }

    // 一時的にmax-heightを解除して実際の高さを取得
    const originalMaxHeight = tags.style.maxHeight
    const originalOverflow = tags.style.overflow
    tags.style.maxHeight = 'none'
    tags.style.overflow = 'visible'

    const fullHeight = tags.scrollHeight

    // 元に戻す
    tags.style.maxHeight = originalMaxHeight
    tags.style.overflow = originalOverflow

    // CSSのmax-height: 60pxと同じ値を超える場合のみボタンを表示
    // 実際の2行分の高さに余裕を持たせる（タグ高さ26px + gap 8px）* 2 = 68px
    const maxVisibleHeight = 68
    if (fullHeight > maxVisibleHeight) {
      toggle.style.display = 'flex'
    } else {
      toggle.style.display = 'none'
    }
  }

  // PC用タグのオーバーフローチェック
  checkOverflowPc() {
    if (!this.hasTagsPcTarget || !this.hasTogglePcTarget) return

    const tags = this.tagsPcTarget
    const toggle = this.togglePcTarget

    // 展開中は非表示にしない
    if (tags.classList.contains('is-expanded')) {
      toggle.style.display = 'flex'
      return
    }

    // 一時的にmax-heightを解除して実際の高さを取得
    const originalMaxHeight = tags.style.maxHeight
    const originalOverflow = tags.style.overflow
    tags.style.maxHeight = 'none'
    tags.style.overflow = 'visible'

    const fullHeight = tags.scrollHeight

    // 元に戻す
    tags.style.maxHeight = originalMaxHeight
    tags.style.overflow = originalOverflow

    // PC: 2行分（約80px）を超える場合はボタンを表示
    const maxVisibleHeight = 85
    if (fullHeight > maxVisibleHeight) {
      toggle.style.display = 'flex'
    } else {
      toggle.style.display = 'none'
    }
  }

  // SP用タグのトグル
  toggle() {
    const tags = this.tagsTarget
    const toggle = this.toggleTarget
    const toggleText = this.toggleTextTarget
    const isExpanded = tags.classList.contains('is-expanded')

    if (isExpanded) {
      tags.classList.remove('is-expanded')
      toggle.classList.remove('is-expanded')
      toggleText.textContent = 'もっと見る'
      // 閉じた後に再度チェック
      this.checkOverflow()
    } else {
      tags.classList.add('is-expanded')
      toggle.classList.add('is-expanded')
      toggleText.textContent = '閉じる'
    }
  }

  // PC用タグのトグル
  togglePc() {
    const tags = this.tagsPcTarget
    const toggle = this.togglePcTarget
    const toggleText = this.toggleTextPcTarget
    const isExpanded = tags.classList.contains('is-expanded')

    if (isExpanded) {
      tags.classList.remove('is-expanded')
      toggle.classList.remove('is-expanded')
      toggleText.textContent = 'もっと見る'
      // 閉じた後に再度チェック
      this.checkOverflowPc()
    } else {
      tags.classList.add('is-expanded')
      toggle.classList.add('is-expanded')
      toggleText.textContent = '閉じる'
    }
  }
})
